import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {ValoracionReseña} from './ValoracionReseña';

export const Reseñas = (props) => {
	const {empresaId, Empresa} = props;

	const [ListaReseñas, setListaReseñas] = useState([]);

	const getReseñas = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'get_Reseñas/?prestadorServicios=' + empresaId,
		})
			.then((response) => {
				setListaReseñas([...response.data]);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	useEffect(() => {
		console.log('empresaId', empresaId)
		getReseñas();
	}, []);

	return (
		<div className='reseñas-perfil-agencia-nuevo'>
			<div className='separador' />
			<div>
				<h3>Reseñas</h3>
			</div>
			{ListaReseñas && ListaReseñas.length > 0
			? ListaReseñas.map((reseña) => (
				<div className='reseña-perfil-agencia'>
					<div className='foto-nombre-reseña'>
						<div className='foto-reseña centrador'>
							<img src='https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.cultura-sorda.org%2Fwp-content%2Fuploads%2F2015%2F02%2FUsuario-Vacio.png&f=1&nofb=1&ipt=c8ee8ae024b252a72f81eff68cece515ba3e9a01ae3af9270059f8b9b1a5f1ad&ipo=images' />
						</div>
						<div className='nombre-reseña centrador'>
							{reseña.cliente.nombre + ' ' + reseña.cliente.apellidos}
						</div>
					</div>
					<div className='estrellas-reseña'>
						<ValoracionReseña numValoracion={reseña.puntuacion} />
					</div>
					<div className='fecha-reseña'>{'Fecha: ' + reseña.fecha}</div>
					<div className='comentario-reseña'>{reseña.comentario}</div>
				</div>
			)):
			<p>Esta empresa aún no tiene reseñas. ¡Sé el primero en puntuar!</p>}
		</div>
	);
};
